import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b32b7bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input p-relative d-flex align-items-center" }
const _hoisted_2 = ["type", "value", "placeholder"]

import { ref } from 'vue'
import IconBase from '@/components/Icons/IconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    modelValue: {},
    type: {},
    placeholder: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any) {

const props = __props



const showPassword = ref(false)

const getType = () => {
  if (props.type !== 'password') {
    return props.type
  }
  return showPassword.value ? 'text' : 'password'
}
const togglePassword = () => {
  showPassword.value = !showPassword.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: getType(),
      value: props.modelValue,
      placeholder: props.placeholder || '',
      onInput: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)
      ))
    }, null, 40, _hoisted_2),
    (_ctx.type === 'password')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "password_toggle",
          onClick: togglePassword
        }, [
          _createVNode(IconBase, {
            name: showPassword.value ? 'close' : 'open',
            "view-box": "0 0 24 24",
            width: 24,
            height: 24
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})